import React, { useState } from 'react'
import { CommonRadio } from '@/components/common'
import {
  SubSection,
  StyledDemoGrid,
  DemoComponent,
  StyledSizeLabel,
} from '../styled.jsx'

export const RadioSection = () => {
  const items = [
    { id: 'a', label: 'Option A' },
    { id: 'b', label: 'Option B' },
    { id: 'c', label: 'Option C' },
  ]

  const [basicValue, setBasicValue] = useState('a')
  const [requiredValue, setRequiredValue] = useState('')
  const [errorValue, setErrorValue] = useState('a')
  const [disabledValue] = useState('b')
  const [tooltipValue, setTooltipValue] = useState('c')

  return (
    <>
      {/* Basic Radios */}
      <SubSection
        title='Radio Variants'
        description='Basic, required, error, disabled and with tooltip'
      >
        <StyledDemoGrid>
          <DemoComponent
            label='Basic'
            component={
              <CommonRadio
                id='demo-radio-basic'
                label='Choose an option'
                items={items}
                value={basicValue}
                setValue={setBasicValue}
              />
            }
            value={basicValue}
          />
          <DemoComponent
            label='Required'
            component={
              <CommonRadio
                id='demo-radio-required'
                label='Required Choice'
                items={items}
                value={requiredValue}
                setValue={setRequiredValue}
                required={true}
                helperText='This is required'
              />
            }
            value={requiredValue}
          />
          <DemoComponent
            label='With Error'
            component={
              <CommonRadio
                id='demo-radio-error'
                label='Enable Feature'
                items={items}
                value={errorValue}
                setValue={setErrorValue}
                error='Selection is invalid'
              />
            }
            value={errorValue}
          />
          <DemoComponent
            label='Disabled'
            component={
              <CommonRadio
                id='demo-radio-disabled'
                label='Disabled Group'
                items={items}
                value={disabledValue}
                setValue={() => {}}
                disabled={true}
              />
            }
            value={disabledValue}
          />
          <DemoComponent
            label='With Tooltip'
            component={
              <CommonRadio
                id='demo-radio-tooltip'
                label='Show Hints'
                items={items}
                value={tooltipValue}
                setValue={setTooltipValue}
                tooltip='Helpful information on hover'
              />
            }
            value={tooltipValue}
          />
        </StyledDemoGrid>
      </SubSection>

      {/* Label Placements */}
      <SubSection
        title='Label Placement'
        description='Positions: end (default), start, top, bottom'
      >
        <StyledSizeLabel variant='h6' gutterBottom>
          Placement Examples
        </StyledSizeLabel>
        <StyledDemoGrid>
          <DemoComponent
            label='End (Default)'
            component={
              <CommonRadio
                id='demo-radio-end'
                label='End Label'
                items={items}
                value={'a'}
                setValue={() => {}}
                row
              />
            }
          />
          <DemoComponent
            label='Start'
            component={
              <CommonRadio
                id='demo-radio-start'
                label='Start Label'
                items={items}
                value={'b'}
                setValue={() => {}}
                labelPlacement='start'
                row
              />
            }
          />
          <DemoComponent
            label='Top'
            component={
              <CommonRadio
                id='demo-radio-top'
                label='Top Label'
                items={items}
                value={'c'}
                setValue={() => {}}
                labelPlacement='top'
                row
              />
            }
          />
          <DemoComponent
            label='Bottom'
            component={
              <CommonRadio
                id='demo-radio-bottom'
                label='Bottom Label'
                items={items}
                value={'a'}
                setValue={() => {}}
                labelPlacement='bottom'
                row
              />
            }
          />
        </StyledDemoGrid>
      </SubSection>
    </>
  )
}
